import { Navigate, useOutlet, useSearchParams } from "react-router-dom";
import { useAuth } from "@hooks/useAuth";
import React,{useEffect} from 'react';
export const ProtectedLayout = () => {
  const { user, logout } = useAuth();
  const outlet = useOutlet();
  const [param, setParam] = useSearchParams();
  useEffect(() => {
    
    if (param.get('softrestart') === 'Y') {
      logout();
    }
  }, [param]);

  if (!user) {
    return <Navigate to="/assertion" />;
  }
  
  return (
    <div>
      {outlet}
    </div>
  );
};
